$(document).ready(function () {
  loadedWidget = false;
  expandOneTime = false;
  const widgetIntent = {
    mode: null,
    plan: null,
  };

  const $form = $(".product-single__form");
  const $btn = $form.find(".btn--add-to-cart");
  const $btnLabel = $btn.find("#subscription-btn");
  const defaultBtnText = $btnLabel.length ? $btnLabel.text() : $btn.text();
  let pendingSubmit = false;
  let allowSubmit = false;

  function disableButton() {
    const $form = $(".product-single__form");
    const $btn = $form.find(".btn--add-to-cart");

    if ($btn.data("rc-loading")) {
      $btn.prop("disabled", true);
      return;
    }

    // 1) Read your force-out-of-stock metafield exposed as data-attribute
    const forceOOS =
      $btn.data("force-oos") === true || $btn.data("force-oos") === "true";
    if (forceOOS) {
      $btn.prop("disabled", true);
      $btn.find("#subscription-btn").text("Sold out");
      return;
    }

    // 2) Fallback to your existing availability logic
    const variantId = $form.find('[name="id"]').val();
    const vairnatAvailable = $form
      .find(`.jc-custom-rc-available[data-variant-id="${variantId}"]`)
      .data("available");

    if (vairnatAvailable) {
      $btn.prop("disabled", true);
      $btn.find("#subscription-btn").text("SOLD OUT");
    } else {
      $btn.prop("disabled", false);
      const rcRadio = $form.find(".jc-custom-rc-radio__input:checked").val();
      if (rcRadio === "subsave") {
        $btn.find("#subscription-btn").text("Add Subscription to Cart");
      } else {
        $btn.find("#subscription-btn").text("Add to Cart");
      }
    }
  }

  /*
    function disableButton() {
        const variantId = $('.product-single__form').find('[name="id"]').val();
        const vairnatAvailable = $('.product-single__form').find(`.jc-custom-rc-available[data-variant-id="${variantId}"]`).data('available');
        const btn = $('.product-single__form').find('.btn--add-to-cart');
        if (vairnatAvailable) {
            btn.prop('disabled', true);
            btn.find('#subscription-btn').text('SOLD OUT');
        } else {
            btn.prop('disabled', false);
            const rcRadio = $('.product-single__form').find('.jc-custom-rc-radio__input:checked');
           
            if (rcRadio.val() == 'subsave') {
                btn.find('#subscription-btn').text('Add Subscription to Cart');
            } else {
                btn.find('#subscription-btn').text('Add to Cart');
            }
        }
    }
    */

  function changePack() {
    const pack = $(".jc-custom-rc-radio__input:checked")
      .next()
      .find(".jc-custom-rc-radio__pack-item.active")
      .data("pack");

    $(".jc-js-quantity-selector").val(pack);

    disableButton();
  }
  function changePlan() {
    const plan = $(".jc-custom-rc-radio__plan-item.active").data("plan");

    setRechargePlan(plan);
    disableButton();
  }
  function formatPrice(p) {
    p = Number(String(p).replace("$", ""));
    let price = p.toFixed(2);
    return String(price).replace(".00", "");
  }
  function updateSubscriptionPrices() {
    // Check if this is a dog chews product - if so, skip dynamic pricing updates
    const productId = $("[data-productid]").attr("data-productid");
    if (productId === "8254875009222" || productId === "8254873075910") {
      return; // Skip pricing updates for dog chews
    }

    const subSaveActivePack = $(
      ".jc-custom-subsave .jc-custom-rc-radio__pack-item.active"
    );
    const subSaveComparePrice = subSaveActivePack
      .find(".jc-custom-rc__compare-price")
      .text()
      .trim();
    const subSaveSalePrice = subSaveActivePack
      .find(".jc-custom-rc__sale-price")
      .text()
      .trim();

    if (subSaveActivePack.length > 0) {
      $(
        ".jc-custom-subsave .jc-custom-rc__price-box .jc-custom-rc__compare-price"
      ).text(`$${formatPrice(subSaveComparePrice)}`);
      $(".jc-custom-subsave .jc-custom-rc__sale-price")
        .first()
        .text(`$${formatPrice(subSaveSalePrice)}`);
    }
  }
  function updateDogChewsPrices() {
    // Custom pricing function for dog chews products
    const activePack =
      $(".jc-custom-onetime .jc-custom-rc-radio__pack-item.active").data(
        "pack"
      ) || 1;

    // Update the quantity selector to match the selected pack
    $(".jc-js-quantity-selector").val(activePack);

    // Clear any selling plan to ensure one-time purchase
    $('[name="selling_plan"]').val("");

    // Read the current variant to pull compare_at_price for strike-through
    const variantId = $(".product-single__form").find('[name="id"]').val();
    let msrpSingle = 50; // fallback
    if (variantId) {
      try {
        const variants = window.variantData || [];
        const v = variants.find((x) => String(x.id) === String(variantId));
        if (v && v.compare_at_price) {
          msrpSingle = Number(v.compare_at_price) / 100;
        }
      } catch (e) {}
    }

    // Target sale prices required by spec
    const sale1 = 20;
    const sale2 = 40;
    const sale3 = 60;

    // Compute strike-through from compare_at (fallback: multiply msrpSingle)
    let compare1 = msrpSingle || 0;
    let compare2 = compare1 ? compare1 * 2 : 0;
    let compare3 = compare1 ? compare1 * 3 : 0;

    // Update the main price display in top-right corner
    const priceElement = $(
      ".jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price"
    );
    if (priceElement.length) {
      const sale = activePack === 1 ? sale1 : activePack === 2 ? sale2 : sale3;
      const cmp =
        activePack === 1 ? compare1 : activePack === 2 ? compare2 : compare3;
      priceElement.html(
        `<span class="compare-price">$${formatPrice(
          cmp
        )}</span> <span class="sale-price red">$${formatPrice(sale)}</span>`
      );
    }

    // Update pack-square prices below the main price box (handle both onetime blocks)
    const $packRoots = $(
      ".jc-custom-onetime.widget, .jc-custom-onetime:not(.widget)"
    );
    if ($packRoots.length) {
      $packRoots.each(function () {
        const $packsRoot = $(this);
        // 1-pack
        $packsRoot
          .find('[data-pack="1"] .pack-price')
          .html(
            `<span class="jc-custom-rc__compare-price" style="text-decoration: line-through;">$${formatPrice(
              compare1
            )}</span> <span class="jc-custom-rc__sale-price standard">$${formatPrice(
              sale1
            )}</span>`
          );
        // 2-pack
        $packsRoot
          .find('[data-pack="2"] .pack-price')
          .html(
            `<span class="jc-custom-rc__compare-price" style="text-decoration: line-through;">$${formatPrice(
              compare2
            )}</span> <span class="jc-custom-rc__sale-price standard">$${formatPrice(
              sale2
            )}</span>`
          );
        // 3-pack
        $packsRoot
          .find('[data-pack="3"] .pack-price')
          .html(
            `<span class="jc-custom-rc__compare-price" style="text-decoration: line-through;">$${formatPrice(
              compare3
            )}</span> <span class="jc-custom-rc__sale-price standard">$${formatPrice(
              sale3
            )}</span>`
          );

        // Update each pack's save pill to ~70%
        $packsRoot
          .find(".jc-custom-rc-radio__pack-item .jc-custom-rc__save-price")
          .each(function () {
            $(this)
              .removeClass("discount no-discount")
              .addClass("dog-chews-save")
              .text("Save ~70%")
              .show();
          });
      });
    }

    // Update save percentage display to ~70%
    const saveElement = $("#dog-chews-save-badge");
    if (saveElement.length) {
      saveElement.text("Save ~70%");
      saveElement
        .removeClass("discount no-discount")
        .addClass("dog-chews-save");
    }
  }

  function updateOneTimePrices() {
    // Check if this is a dog chews product - if so, use custom dog chews pricing logic
    const productId = $("[data-productid]").attr("data-productid");
    if (productId === "8254875009222" || productId === "8254873075910") {
      updateDogChewsPrices();
      return;
    }

    // Get the currently active pack in the One-Time Purchase section
    let oneTimeActivePack = $(
      ".jc-custom-onetime.widget .jc-custom-rc-radio__pack-item.active"
    );

    if (oneTimeActivePack.length > 0) {
      // Get data for the active pack
      if (!loadedWidget || !expandOneTime)
        oneTimeActivePack = $(
          '.jc-custom-onetime.widget .jc-custom-rc-radio__pack-item[data-pack="1"]'
        );
      const oneTimeComparePrice = oneTimeActivePack
        .find(".jc-custom-rc__compare-price")
        .text()
        .trim();
      const oneTimeSalePrice = oneTimeActivePack
        .find(".jc-custom-rc__sale-price")
        .text()
        .trim();
      const packDiscountText = oneTimeActivePack
        .find(".jc-custom-rc__save-price")
        .text()
        .trim();

      // Update the main price box with compare and sale prices
      const cmpNum = Number(String(oneTimeComparePrice).replace('$', '')) || 0;
      const saleNum = Number(String(oneTimeSalePrice).replace('$', '')) || 0;
      const $box = $(
        ".jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price"
      );
      if (cmpNum > 0 && cmpNum > saleNum) {
        $box.html(
          `<span class="compare-price">$${formatPrice(cmpNum)}</span> <span class="sale-price">$${formatPrice(saleNum)}</span>`
        );
      } else {
        $box.html(
          `<span class=\"sale-price\">$${formatPrice(saleNum)}</span>`
        );
      }

      // Ensure pack tiles are NEVER red (PDP only)
      $(".jc-custom-rc-radio__packs .jc-custom-rc__sale-price")
        .removeClass("red")
        .addClass("standard");

      const variantId = $('[name="id"]').val();
      const variantDiscVal = parseInt(
        $(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`).data(
          "discount"
        ) || 0,
        10
      );

      // If the variant has its own discount, skip pill-text updates (but we already did prices)
      if (variantDiscVal > 0) {
        return;
      }

      // Update the discount message in the main price box
      const discountElement = $(
        ".jc-custom-onetime .jc-custom-rc__save-price.main"
      );
      discountElement.text(packDiscountText || "No Discount");

      // Add or remove the "no-discount" class based on the discount text
      if (packDiscountText === "No Discount") {
        discountElement.addClass("no-discount");
      } else {
        discountElement.removeClass("no-discount");
      }
    } else {
      // Fallback: if no active pack is selected
      const discountElement = $(
        ".jc-custom-onetime .jc-custom-rc__save-price.main"
      );
      $(
        ".jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price"
      ).html("");
      discountElement.text("No Discount").addClass("no-discount");
    }
  }

  /*
    const $subPill = $('.jc-custom-subsave .jc-custom-rc-radio__price .jc-custom-rc__save-price');
    const origSubText = $subPill.data('default-text');
    const $oneTimePill = $('.jc-custom-onetime .jc-custom-rc-radio__price .jc-custom-rc__save-price');
    const origOneTimeText = "No Discount";
    */
  const $subPill = $(
    ".jc-custom-subsave .jc-custom-rc-radio__price .jc-custom-rc__save-price"
  );
  const origSubText = $subPill.text().trim();

  /*
    const $oneTimePill    = $('.jc-custom-onetime .jc-custom-rc-radio__price .jc-custom-rc__save-price');
    const origOneTimeText = $oneTimePill.text().trim();
    */
  const $oneTimePill = $(
    ".jc-custom-onetime .jc-custom-rc-radio__price .jc-custom-rc__save-price"
  );
  const origOneTimeText = "No Discount";

  function changeVariant() {
    // Check if this is a dog chews product - if so, skip dynamic pricing updates
    const productId = $("[data-productid]").attr("data-productid");
    if (productId === "8254875009222" || productId === "8254873075910") {
      return; // Skip pricing updates for dog chews
    }

    const variantId = $('[name="id"]').val();
    const $discEl = $(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`);
    const discountVal = parseInt($discEl.data("discount") || 0, 10);
    const hasDiscount = discountVal > 0;
    var price = Number(
      $("[data-price-onetime]").text().trim().replace("$", "")
    );
    const customDiscount =
      1 -
      Number(
        $(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`).data(
          "discount"
        )
      ) /
        100;

    // Only color the MAIN price in the price box, not the pack tiles
    const $subSaleEls = $(".jc-custom-subsave .jc-custom-rc__price-box .jc-custom-rc__sale-price");
    const $oneTimeSaleEls = $(".jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price");

    const rawNote = window.variantPillPriceNotes[variantId] || "";

    // log it so you can see exactly what came through
    console.log("variant", variantId, "→", rawNote);

    $subSaleEls
      .toggleClass("red", hasDiscount)
      .toggleClass("standard", !hasDiscount);
    $oneTimeSaleEls
      .toggleClass("red", hasDiscount)
      .toggleClass("standard", !hasDiscount);

    // Ensure pack tiles are NEVER red (PDP only)
    $(".jc-custom-rc-radio__packs .jc-custom-rc__sale-price")
      .removeClass("red")
      .addClass("standard");

    /*
            if (hasDiscount) {
                $subPill
                  .addClass('discount')
                  .text(`Save ~${discountVal}%`);
            
                $oneTimePill
                  .addClass('discount')
                  .removeClass('no-discount')
                  .text(`Save ${discountVal}%`);
              } else {
                $subPill
                  .removeClass('discount')
                  .text(origSubText);
            
                $oneTimePill
                  .removeClass('discount')
                  .addClass('no-discount')
                  .text(origOneTimeText);
              }
              */
    // 1) Subscribe & Save pill
    const subNote = window.variantPillPriceNotes[variantId];
    if (hasDiscount) {
      const noteText = subNote || `Save ${discountVal}%`;
      $subPill.text(noteText).removeClass("no-discount").addClass("discount");
    } else {
      const noteText = subNote || origSubText;
      $subPill.text(noteText).removeClass("discount");
    }

    // 2) One-Time Purchase pill
    if (hasDiscount) {
      $oneTimePill
        .addClass("discount")
        .removeClass("no-discount")
        .text(`Save ${discountVal}%`);
    } else {
      $oneTimePill
        .removeClass("discount")
        .addClass("no-discount")
        .text(origOneTimeText);
    }

    if (customDiscount) {
      document
        .querySelector(".jc-custom-rc-container")
        .classList.remove("no-discount-container");
      $(".jc-custom-rc__compare-price").text(`$${formatPrice(price)}`);
      $('[data-pack="2"]')
        .find(".jc-custom-rc__compare-price")
        .text(`$${formatPrice(price * 2)}`);
      $('[data-pack="3"]')
        .find(".jc-custom-rc__compare-price")
        .text(`$${formatPrice(price * 3)}`);

      if (loadedWidget && expandOneTime) {
        const activePack = $(".jc-custom-onetime")
          .find(".jc-custom-rc-radio__pack-item.active")
          .data("pack");
        $(".jc-custom-onetime")
          .find(".jc-custom-rc__sale-price")
          .html(
            `<span class="compare-price">$${formatPrice(
              price * activePack
            )}</span> <span class="sale-price">$${formatPrice(
              price * activePack * customDiscount
            )}</span>`
          );
      } else {
        $(".jc-custom-onetime")
          .find(".jc-custom-rc__sale-price")
          .html(
            `<span class="compare-price">$${formatPrice(
              price
            )}</span> <span class="sale-price">$${formatPrice(
              price * customDiscount
            )}</span>`
          );
      }
      $(".jc-custom-onetime")
        .find('[data-pack="1"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * customDiscount)}`);
      $(".jc-custom-onetime")
        .find('[data-pack="2"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 2 * customDiscount)}`);
      $(".jc-custom-onetime")
        .find('[data-pack="3"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 3 * customDiscount)}`);

      $(".jc-custom-subsave")
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 0.8 * customDiscount)}`);
      $(".jc-custom-subsave")
        .find('[data-pack="1"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 0.8 * customDiscount)}`);
      $(".jc-custom-subsave")
        .find('[data-pack="2"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 2 * 0.8 * customDiscount)}`);
      $(".jc-custom-subsave")
        .find('[data-pack="3"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 3 * 0.8 * customDiscount)}`);
    } else {
      document
        .querySelector(".jc-custom-rc-container")
        .classList.add("no-discount-container");
      $(".jc-custom-rc__compare-price").text(`$${formatPrice(price)}`);
      $('[data-pack="2"]')
        .find(".jc-custom-rc__compare-price")
        .text(`$${formatPrice(price * 2)}`);
      $('[data-pack="3"]')
        .find(".jc-custom-rc__compare-price")
        .text(`$${formatPrice(price * 3)}`);

      $(".jc-custom-onetime")
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price)}`);
      $(".jc-custom-onetime")
        .find('[data-pack="1"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price)}`);
      $(".jc-custom-onetime")
        .find('[data-pack="2"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 2 * 0.9)}`);
      $(".jc-custom-onetime")
        .find('[data-pack="3"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 3 * 0.85)}`);

      // No variant-level discount: ensure 1-pack does not render a compare-at (avoid same price struck out)
      $(".jc-custom-onetime")
        .find('[data-pack="1"] .jc-custom-rc__compare-price')
        .text("");

      $(".jc-custom-subsave")
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 0.8)}`);
      $(".jc-custom-subsave")
        .find('[data-pack="1"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 0.8)}`);
      $(".jc-custom-subsave")
        .find('[data-pack="2"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 2 * 0.8)}`);
      $(".jc-custom-subsave")
        .find('[data-pack="3"]')
        .find(".jc-custom-rc__sale-price")
        .text(`$${formatPrice(price * 3 * 0.8)}`);
    }
    const activePack = $(".jc-custom-rc-radio__pack-item.active").data("pack");
    updatePackPrices(activePack);
    disableButton();

    showDiscountBadgeIfAny();
  }
  function updatePackPrices(activePack) {
    if (activePack) {
      // Update based on the current active pack
      if ($(".jc-custom-rc-radio__input:checked").val() == "subsave") {
        updateSubscriptionPrices();
      } else {
        updateOneTimePrices();
      }
    }
  }
  const location_search = window.location.search;
  var searchInterval = setInterval(searchElement, 100); // short interval

  function stopSearch() {
    clearInterval(searchInterval);
  }

  function searchElement() {
    if ($("[data-widget-container-wrapper]").length > 0) {
      updatePrices();
      setTimeout(function () {
        const location_search = window.location.search;

        if (location_search.indexOf("?variant=") === -1) {
          const $radio = $('.single-option-selector__radio[value="2500mg"]');
          if ($radio.length) {
            // 1) check it
            $radio.prop("checked", true);
            // 2) fire your change listener
            $radio.trigger("change");
            // 3) explicitly run your price-update routine
            changeVariant();
          } else {
            const $alt = $('.jc-input-index-2[name="potency"]');
            $alt.prop("checked", true).trigger("change");
            changeVariant();
          }
        }

        // Hide spinner and show widget
        $(".jc-custom-rc-loading").hide();
        markWidgetReady();

        // Check if this is a dog chews product and initialize pricing
        const productId = $("[data-productid]").attr("data-productid");
        if (productId === "8254875009222" || productId === "8254873075910") {
          updateDogChewsPrices();
        } else {
          changeVariant();
        }

        stopSearch();
      }, 100);
    }
  }

  /*
    function showDiscountBadgeIfAny() {
        
        // how many badges are we about to clear?
        const removed = document.querySelectorAll('.discount-tab.pdp').length;
        
        // now clear them
        document.querySelectorAll('.discount-tab.pdp').forEach(el => el.remove());
        
        // read the current variant’s discount
        const variantId   = $('[name="id"]').val();
        const discountVal = parseInt(
          $(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`).data('discount') || 0,
          10
        );
        if (discountVal <= 0) {
          return;
        }
      
        // append the badge
        const $firstPane = $('.tabs-content-product .w-tab-pane.w--tab-active').first();
        if ($firstPane.length) {
          const badge = $(`
            <div class="discount-tab pdp">
              <span class="discount-text">save</span>
              <span class="discount-text bigger">${discountVal}%</span>
            </div>
          `);
          $firstPane.append(badge);
        }
      }

      $('.tabs-content-product .w-tab-pane').each(function() {
        const pane = this;
        const obs = new MutationObserver(muts => {
          muts.forEach(m => {
            if (m.attributeName === 'class' &&
                pane.classList.contains('w--tab-active')) {
              showDiscountBadgeIfAny();
            }
          });
        });
        obs.observe(pane, { attributes: true, attributeFilter: ['class'] });
      });
      */
  // 1) Show/hide badge only on matching pane
  function showDiscountBadgeIfAny() {
    // 1a) clear existing badges
    $(".discount-tab.pdp").remove();

    // 1b) read current variant & its discount
    const variantId = $('[name="id"]').val();
    const $discEl = $(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`);
    const discountVal = parseInt($discEl.data("discount") || 0, 10);
    if (discountVal <= 0) return;

    // 1c) read which image this variant “owns”
    const variantImageId = parseInt($discEl.data("image-id") || 0, 10);

    // 1d) read the active pane’s image id
    const $activePane = $(".tabs-content-product .w-tab-pane.w--tab-active");
    const paneImageId = parseInt($activePane.data("image-id") || 0, 10);

    // 1e) only badge if they match
    if (variantImageId !== paneImageId) return;

    // 1f) append the badge
    const $badge = $(`
      <div class="discount-tab pdp">
        <span class="discount-text">save</span>
        <span class="discount-text bigger">${discountVal}%</span>
      </div>
    `);
    $activePane.append($badge);
  }

  // 2) re-run on tab-pane activation
  $(".tabs-content-product .w-tab-pane").each(function () {
    const pane = this;
    const obs = new MutationObserver((muts) => {
      muts.forEach((m) => {
        if (
          m.attributeName === "class" &&
          pane.classList.contains("w--tab-active")
        ) {
          showDiscountBadgeIfAny();
        }
      });
    });
    obs.observe(pane, { attributes: true, attributeFilter: ["class"] });
  });

  // 3) re-run on variant change
  $(".single-option-selector__radio, .product-single__variants").on(
    "change",
    showDiscountBadgeIfAny
  );

  // 4) initial pass
  $(document).ready(showDiscountBadgeIfAny);

  function updatePromoDisclaimer() {
    // Get the currently selected variant's ID
    const selectedVariantId = $(".product-single__variants").val();
    $(".promo-pdp-disclaimer").addClass("hidden");
    if (!selectedVariantId) return;
    $(
      `.promo-pdp-disclaimer[data-variant-id="${selectedVariantId}"]`
    )?.removeClass("hidden");
  }

  $(document).on(
    "change",
    ".jc-product-page-form-wrapper .single-option-selector__radio",
    function () {
      changeVariant();
    }
  );

  $(document).on(
    "click",
    ".jc-product-page-form-wrapper .jc-custom-rc-radio__pack-item",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (
        $(this).closest(".jc-custom-rc-radio").hasClass("jc-custom-subsave")
      ) {
        $(this)
          .closest(".jc-custom-rc-radio__packs")
          .find(".jc-custom-rc-radio__pack-item")
          .removeClass("active");
        $(this).addClass("active");
        changePack();
        updateSubscriptionPrices();
      } else if (
        $(this).closest(".jc-custom-rc-radio").hasClass("jc-custom-onetime")
      ) {
        $(this)
          .closest(".jc-custom-rc-radio__packs")
          .find(".jc-custom-rc-radio__pack-item")
          .removeClass("active");
        $(this).addClass("active");
        changePack();

        // Check if this is a dog chews product and call appropriate function
        const productId = $("[data-productid]").attr("data-productid");
        if (productId === "8254875009222" || productId === "8254873075910") {
          updateDogChewsPrices();
        } else {
          updateOneTimePrices();
        }
      }
    }
  );

  $(document).on(
    "click",
    ".jc-product-page-form-wrapper .jc-custom-ra-radio-wrapper",
    function (e) {
      updateSubscriptionPrices();
      updateOneTimePrices();
    }
  );

  $(document).on(
    "change",
    ".jc-product-page-form-wrapper .jc-custom-rc-radio__input",
    function () {
      expandOneTime = true;
      const selectedMode = $(".jc-custom-rc-radio__input:checked").val();
      if (selectedMode == "subsave") {
        syncRechargeMode("subsave");
        $("#subscription-btn").text("Add Subscription to Cart");
        if ($(window).width() < 768) {
          $("#disclaimer-text").html(
            "60-Day Money-Back Guarantee<br> Free U.S. Shipping"
          );
        } else {
          $("#disclaimer-text").text(
            "60-Day Money-Back Guarantee | Free U.S. Shipping"
          );
        }
      } else {
        syncRechargeMode("onetime");
        $("#subscription-btn").text("Add to Cart");
        $("#disclaimer-text").text(
          "60-Day Money-Back Guarantee | Free U.S. Shipping Over $60"
        );
        if ($(window).width() < 768) {
          $("#disclaimer-text").html(
            "60-Day Money-Back Guarantee<br>Free U.S. Shipping Over $60"
          );
          $("body, html").scrollTop(
            $(".jc-custom-onetime").position().top + 540
          );
        } else {
          $("#disclaimer-text").text(
            "60-Day Money-Back Guarantee | Free U.S. Shipping Over $60"
          );
        }
      }
      changePack();
      if ($(".jc-custom-rc-radio__input:checked").val() == "subsave") {
        updateSubscriptionPrices();
      } else {
        updateOneTimePrices();
      }
      if (
        $(this)
          .closest(".jc-custom-rc-container")
          .find(".btn--add-to-cart")
          .prop("disabled")
      ) {
        $(this)
          .closest(".jc-custom-rc-container")
          .find(".btn--add-to-cart")
          .find("#subscription-btn")
          .text("Sold out");
      }
  }
  );

  $btn.on("click", function (event) {
    console.log("[rc] button click", {
      allowSubmit,
      loadedWidget,
      pendingSubmit,
      selectedMode: $(".jc-custom-rc-radio__input:checked").val(),
    });
    if (allowSubmit) {
      allowSubmit = false;
      console.log("[rc] allowSubmit true → letting click continue");
      return;
    }

    const selectedMode =
      $(".jc-custom-rc-radio__input:checked").val() || "onetime";
    if (!loadedWidget && selectedMode === "subsave") {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!$btn.data("rc-loading")) {
        setButtonLoadingState(true);
      }
      pendingSubmit = true;
      console.log("[rc] queued click until widget ready");
      return false;
    }
  });

  $form.on("submit", function (event) {
    console.log("[rc] form submit", { allowSubmit, loadedWidget, pendingSubmit });
    if (allowSubmit) {
      allowSubmit = false;
      console.log("[rc] allowSubmit true → letting submit continue");
      return;
    }

    const selectedMode =
      $(".jc-custom-rc-radio__input:checked").val() || "onetime";
    if (!loadedWidget && selectedMode === "subsave") {
      event.preventDefault();
      if (!$btn.data("rc-loading")) {
        setButtonLoadingState(true);
      }
      pendingSubmit = true;
      console.log("[rc] prevented submit until widget ready");
      return false;
    }
  });

  // Event listener for plan items
  $(document).on(
    "click",
    ".jc-product-page-form-wrapper .jc-custom-rc-radio__plan-item",
    function () {
      $(".jc-custom-rc-radio__plan-item").removeClass("active");
      $(this).addClass("active");
      changePlan();
  }
  );

  // Update the disclaimer when the variant changes
  $(document).on(
    "change",
    ".jc-product-page-form-wrapper .single-option-selector__radio",
    function () {
      updatePromoDisclaimer();
    }
  );

  // Ensure disclaimer is set correctly on initial page load
  $(document).ready(function () {
    updatePromoDisclaimer();
  });

  // Hard timeout: stop spinner after 60s (fallback)
  setTimeout(function () {
    stopSearch();
    $(".jc-custom-rc-loading").hide();
    markWidgetReady(false);
  }, 60000);

  function updatePrices() {
    document
      .querySelectorAll(".jc-custom-rc__compare-price")
      .forEach((priceElement) => {
        const price = formatPrice(priceElement.textContent.trim());
        priceElement.textContent = `$${price}`;
      });

    document
      .querySelectorAll(".jc-custom-rc__sale-price")
      .forEach((priceElement) => {
        if (priceElement.querySelector(".compare-price")) {
          const compareAtPrice = formatPrice(
            priceElement.querySelector(".compare-price").textContent.trim()
          );
          priceElement.querySelector(
            ".compare-price"
          ).textContent = `$${compareAtPrice}`;

          const salePrice = formatPrice(
            priceElement.querySelector(".sale-price").textContent.trim()
          );
          priceElement.querySelector(
            ".sale-price"
          ).textContent = `$${salePrice}`;
        } else {
          const price = formatPrice(priceElement.textContent.trim());
          priceElement.textContent = `$${price}`;
        }
      });
  }

  function setButtonLoadingState(isLoading) {
    const $btn = $(".product-single__form").find(".btn--add-to-cart");
    if (!$btn.length) return;

    const $label = $btn.find("#subscription-btn");

    $btn.data("rc-loading", isLoading);
    if (isLoading) {
      $btn.addClass("is-loading").attr("aria-busy", "true").prop("disabled", true);
      if ($label.length) {
        if (!$label.data("default-text")) {
          $label.data("default-text", $label.text());
        }
        $label.text("Loading options…");
      } else {
        if (!$btn.data("default-text") && defaultBtnText) {
          $btn.data("default-text", defaultBtnText);
        }
        $btn.text("Loading options…");
      }
    } else {
      $btn.removeClass("is-loading").attr("aria-busy", "false");
      if (!$label.length && $btn.data("default-text")) {
        $btn.text($btn.data("default-text"));
      }
      disableButton();
    }
  }

  function markWidgetReady(detectedWidget = true) {
    if (loadedWidget) return;
    loadedWidget = true;

    if (!detectedWidget) {
      console.log("[rc] markWidgetReady fallback (timeout)");
      setButtonLoadingState(false);
      return;
    }

    console.log("[rc] markWidgetReady detected Recharge");
    applyPendingIntent();

    if (pendingSubmit) {
      allowSubmit = true;
      setTimeout(function () {
        pendingSubmit = false;
        console.log("[rc] replaying queued click");
        $btn.prop("disabled", false);
        const nativeBtn = $btn.get(0);
        if (nativeBtn && typeof nativeBtn.click === "function") {
          nativeBtn.click();
        } else {
          $btn.trigger("click");
        }

        requestAnimationFrame(function () {
          setButtonLoadingState(false);
        });
      }, 0);
      return;
    }

    console.log("[rc] widget ready with no queued click");
    setButtonLoadingState(false);
  }

  function applyPendingIntent() {
    const pendingMode = widgetIntent.mode ||
      $(".jc-custom-rc-radio__input:checked").val();
    syncRechargeMode(pendingMode, true);

    const activePlan = $(".jc-custom-rc-radio__plan-item.active").data("plan");
    const planToApply =
      typeof widgetIntent.plan === "number" ? widgetIntent.plan : activePlan;
    if (typeof planToApply === "number" && !Number.isNaN(planToApply)) {
      setRechargePlan(planToApply);
    }

    widgetIntent.mode = null;
    widgetIntent.plan = null;
  }

  function syncRechargeMode(mode, skipPendingStore) {
    if (!mode) return;

    if (!loadedWidget) {
      if (!skipPendingStore) {
        widgetIntent.mode = mode;
      }
      return;
    }

    const $target = $(`.rc-radio__input[value="${mode}"]`);
    if (!$target.length) {
      return;
    }

    if (!$target.prop("checked")) {
      $target.trigger("click");
    } else {
      $target.trigger("change");
    }
  }

  function setRechargePlan(planIndex) {
    if (!loadedWidget) {
      widgetIntent.plan = planIndex;
      return;
    }

    const $option = $(`.rc_widget__option__plans__dropdown>option:eq(${planIndex})`);
    if ($option.length) {
      $option.prop("selected", true).trigger("change");
    }
  }

  // ================= Variant Gallery: A | base | D swapper =================
  function getSectionId() {
    const el = document.querySelector(
      ".jc-product-page-wrapper[data-section-id]"
    );
    return el ? el.getAttribute("data-section-id") : "";
  }

  function getCurrentVariantIdSimple() {
    const byForm = document.querySelector('.product-single__form [name="id"]');
    if (byForm && byForm.value) return String(byForm.value);
    const bySelect = document.getElementById("ProductSelect");
    if (bySelect && bySelect.value) return String(bySelect.value);
    const urlVar = new URLSearchParams(window.location.search).get("variant");
    return urlVar ? String(urlVar) : "";
  }

  // Token to avoid race conditions when switching variants quickly
  let __variantGallerySwapNonce = 0;

  function renderVariantTabs(sectionId, variantId) {
    try {
      const holder = document.getElementById(`VariantGalleryMap-${sectionId}`);
      if (!holder) return;
      const map = JSON.parse(holder.textContent || "{}");
      if (!map || !map.base) return;

      const normalize = (u) => (u || "").replace(/^https?:/i, "");
      const allUnique = !!map.allUnique;
      const vEntry = (map.variants && map.variants[variantId]) || {};
      const gallery = Array.isArray(vEntry.g)
        ? vEntry.g.map((o) => (o && o.src ? o.src : o)).filter(Boolean)
        : [];

      const bySrc = new Map();
      map.base.forEach((img) => bySrc.set(normalize(img.src), String(img.id)));

      let sequence = [];
      if (allUnique && gallery.length) {
        sequence = gallery.map((src, idx) => {
          const key = bySrc.get(normalize(src)) || `v-${variantId}-${idx + 1}`;
          return { key, src };
        });
      } else {
        sequence = map.base.map((img) => ({
          key: String(img.id),
          src: img.src,
        }));
      }

      const container = document.querySelector(
        ".tabs-wrapper-product .tabs-product"
      );
      if (!container) return;
      const menu = container.querySelector(".tabs-menu-product");
      const panes = container.querySelector(".tabs-content-product");
      if (!menu || !panes) return;

      const isBootstrapped =
        container.getAttribute("data-gallery-bootstrapped") === "1";

      if (!sequence.length) return;

      const newMenuHTML = sequence
        .map(
          (it, i) =>
            `<a href="#" data-image-id="${it.key}" class="tab-menu-link-product w-inline-block${i ? "" : " w--current"}" style="background-image:url(${it.src});"></a>`
        )
        .join("");

      const newPanesHTML = sequence
        .map((it, i) => {
          const eager = i === 0 ? "eager" : "lazy";
          const prio = i === 0 ? "high" : "auto";
          return (
            `<div class="w-tab-pane${
              i ? "" : " w--tab-active"
            }" data-image-id="${it.key}">` +
            `<div class=\"tab-inner-product\"><div class=\"tab-img-wrapper-product\"><div class=\"tab-img-inner-product\">` +
            `<img src="${it.src}" loading="${eager}" fetchpriority="${prio}" decoding="async" alt="" class="tab-img-product" />` +
            `</div></div></div>` +
            `</div>`
          );
        })
        .join("");

      const firstSrc = sequence[0] && sequence[0].src;
      const nonce = ++__variantGallerySwapNonce;

      const preloadImage = (src) =>
        new Promise((resolve) => {
          if (!src) return resolve();
          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            resolve();
          };
          try {
            const img = new Image();
            img.addEventListener("load", finish, { once: true });
            img.addEventListener("error", finish, { once: true });
            img.src = src;
            if (img.decode) img.decode().then(finish).catch(finish);
          } catch (e) {
            finish();
          }
        });

      const withTimeout = (p, ms) =>
        new Promise((resolve) => {
          let t = setTimeout(resolve, ms);
          p.then(() => {
            clearTimeout(t);
            resolve();
          }).catch(() => {
            clearTimeout(t);
            resolve();
          });
        });

      const waitForFirst = () => preloadImage(firstSrc);
      const thumbCount = Math.min(5, sequence.length);
      const thumbPreloads = Promise.all(
        sequence.slice(0, thumbCount).map((it) => preloadImage(it.src))
      );

      Promise.all([waitForFirst(), withTimeout(thumbPreloads, 800)]).then(() => {
        if (nonce !== __variantGallerySwapNonce) return;

        const range = document.createRange();
        const fragMenu = range.createContextualFragment(newMenuHTML);
        const fragPanes = range.createContextualFragment(newPanesHTML);

        let overlay;
        if (isBootstrapped) {
          try {
            const activePane =
              panes.querySelector(".w-tab-pane.w--tab-active") ||
              panes.querySelector(".w-tab-pane");
            if (activePane) {
              overlay = document.createElement("div");
              overlay.className = "gallery-overlay";
              const inner = activePane.querySelector(".tab-inner-product");
              if (inner) {
                overlay.appendChild(inner);
              } else {
                overlay.innerHTML = activePane.innerHTML;
              }
              panes.appendChild(overlay);
            }
          } catch (e) {}
        }

        let menuOverlay;
        if (isBootstrapped) {
          try {
            menuOverlay = document.createElement("div");
            menuOverlay.className = "gallery-menu-overlay";
            menuOverlay.innerHTML = menu.innerHTML;
          } catch (e) {}
        }

        menu.innerHTML = "";
        menu.appendChild(fragMenu);
        if (menuOverlay) menu.appendChild(menuOverlay);

        try {
          const prevRect = panes.getBoundingClientRect();
          if (prevRect && prevRect.height) {
            panes.style.minHeight = Math.ceil(prevRect.height) + "px";
          }
        } catch (_) {}

        panes.querySelectorAll(".w-tab-pane").forEach((n) => n.remove());
        panes.appendChild(fragPanes);

        panes.querySelectorAll("img.tab-img-product").forEach((img) => {
          if (img.complete) {
            try {
              img.decode
                ? img
                    .decode()
                    .then(() => img.classList.add("is-loaded"))
                    .catch(() => img.classList.add("is-loaded"))
                : img.classList.add("is-loaded");
            } catch (e) {
              img.classList.add("is-loaded");
            }
          } else {
            img.addEventListener(
              "load",
              function onL() {
                img.classList.add("is-loaded");
              },
              { once: true }
            );
          }
        });

        const firstActiveImg = panes.querySelector(
          ".w-tab-pane.w--tab-active img.tab-img-product"
        );
        if (firstActiveImg) {
          firstActiveImg.classList.add("is-loaded");
        }

        menu.querySelectorAll("a").forEach((link) => {
          link.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === "function") {
              e.stopImmediatePropagation();
            }

            const lingering = panes.querySelector(".gallery-overlay");
            if (lingering) lingering.remove();
            const lingeringMenu = menu.querySelector(".gallery-menu-overlay");
            if (lingeringMenu) lingeringMenu.remove();

            const key = link.getAttribute("data-image-id");

            menu.querySelectorAll("a").forEach((a) => {
              a.classList.toggle("w--current", a === link);
            });

            panes.querySelectorAll(".w-tab-pane").forEach((pane) => {
              pane.classList.toggle(
                "w--tab-active",
                pane.getAttribute("data-image-id") === key
              );
            });

            const targetImg = panes.querySelector(
              `.w-tab-pane[data-image-id="${key}"] img.tab-img-product`
            );
            if (targetImg) {
              try {
                if (targetImg.complete) {
                  if (targetImg.decode) {
                    targetImg
                      .decode()
                      .then(() => targetImg.classList.add("is-loaded"))
                      .catch(() => targetImg.classList.add("is-loaded"));
                  } else {
                    targetImg.classList.add("is-loaded");
                  }
                } else {
                  targetImg.addEventListener(
                    "load",
                    () => targetImg.classList.add("is-loaded"),
                    { once: true }
                  );
                }
              } catch (_) {
                targetImg.classList.add("is-loaded");
              }
            }
          });
        });

        if (overlay) {
          requestAnimationFrame(() => {
            overlay.classList.add("is-fade-out");
          });
          const remove = () => overlay && overlay.remove();
          overlay.addEventListener(
            "transitionend",
            () => {
              remove();
              panes.style.minHeight = "";
            },
            { once: true }
          );
          setTimeout(() => {
            remove();
            panes.style.minHeight = "";
          }, 400);
        }

        if (menuOverlay) {
          requestAnimationFrame(() => {
            menuOverlay.classList.add("is-fade-out");
          });
          const removeMenu = () => menuOverlay && menuOverlay.remove();
          menuOverlay.addEventListener("transitionend", removeMenu, {
            once: true,
          });
          setTimeout(removeMenu, 400);
        }

        if (!overlay) {
          requestAnimationFrame(() => {
            panes.style.minHeight = "";
          });
        }

        if (!isBootstrapped) {
          container.setAttribute("data-gallery-bootstrapped", "1");
        }
      });
    } catch (e) {
      console.error("renderVariantTabs error", e);
    }
  }

  (function initVariantGallerySwap() {
    const sectionId = getSectionId();
    if (!sectionId) return;
    const initialVid = getCurrentVariantIdSimple();
    if (initialVid) {
      renderVariantTabs(sectionId, initialVid);
    }
    $(document).on(
      "change",
      '.single-option-selector__radio, .product-single__variants, [name="id"]',
      function () {
        const vid = getCurrentVariantIdSimple();
        if (vid) renderVariantTabs(sectionId, vid);
      }
    );
  })();

  disableButton();
});
